import { render, staticRenderFns } from "./ScreenTransvaginalUteroComDoppler.vue?vue&type=template&id=8f8b5aba&scoped=true&"
import script from "./ScreenTransvaginalUteroComDoppler.vue?vue&type=script&lang=js&"
export * from "./ScreenTransvaginalUteroComDoppler.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTransvaginalUteroComDoppler.vue?vue&type=style&index=0&id=8f8b5aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8b5aba",
  null
  
)

export default component.exports